import React from 'react'
import { Link } from 'react-router-dom'
import LabeledValue from '../../../../components/common/LabeledValue'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'

interface RetractionDetailFieldsProps {
  data: TimeOffRequestDetails
  isAdminMode: boolean
  showDenialReason?: boolean
}

/**
 * Renders shared partial-retraction metadata fields used by multiple status detail views.
 */
const RetractionDetailFields: React.FC<RetractionDetailFieldsProps> = ({
  data,
  isAdminMode,
  showDenialReason = false,
}) => {
  return (
    <>
      {data.retractionApprovedOn && (
        <div className="mb-4">
          <LabeledValue
            label="Partial Retraction Approved On"
            value={data.retractionApprovedOn}
          />
        </div>
      )}
      {data.retractionDeniedOn && (
        <div className="mb-4">
          <LabeledValue
            label="Partial Retraction Denied On"
            value={data.retractionDeniedOn}
          />
        </div>
      )}

      {data.authorizedApprover && (
        <div className="mb-4">
          <LabeledValue
            label="Authorized Approver"
            value={data.authorizedApprover}
          />
        </div>
      )}

      {(data.requestRank != null || isVacationBid(data)) && (
        <div className="mb-4">
          <LabeledValue label="Request Rank" value={data.requestRank == null ? 'NA' : String(data.requestRank)} />
        </div>
      )}

      {data.originalRequestId && (
        <div className="mb-4">
          <LabeledValue
            label="Original Time Off Request ID"
            value={
              <Link
                to={
                  isAdminMode
                    ? `/admin/requestor/status/${data.originalRequestId}`
                    : `/requestor/status/${data.originalRequestId}`
                }
                className="text-blue-600 underline hover:text-blue-800"
              >
                {data.originalRequestId}
              </Link>
            }
          />
        </div>
      )}

      {showDenialReason && data.denialReason && (
        <div className="mb-4">
          <LabeledValue label="Denial Reason" value={data.denialReason} />
        </div>
      )}

      <div className="mb-4">
        <LabeledValue label="Approver Comments" value={data.approverComments || '-'} />
      </div>
    </>
  )
}

export default RetractionDetailFields
